<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-demo"
    mode="horizontal"
    active-text-color="#00AEEF"
    text-color="#282F3C"
  >
    <el-menu-item index="1">
      <router-link to="/">首页</router-link> 
      </el-menu-item>
    <el-submenu index="2">
      <template slot="title">泛载雾计算</template>
      <el-menu-item index="2-1">
        <router-link to="/compute">CCD</router-link> 
      </el-menu-item>
      <!-- <el-submenu index="2-2">
        <template slot="title">高质量动态代理</template>
        <el-menu-item index="2-2-1">
          <router-link to="/dynamic">产品介绍</router-link> 
        </el-menu-item>
        <el-menu-item index="2-2-2">
          <router-link to="/ipDetail">产品优势</router-link> 
        </el-menu-item>
        <el-menu-item index="2-2-3">
          <router-link to="/customerCase">客户案例</router-link> 
        </el-menu-item>
      </el-submenu> -->
      <el-menu-item index="2-3">
        <router-link to="/cache">分布式存储</router-link> 
      </el-menu-item>
      <el-menu-item index="2-4">
        <router-link to="/dataChanel">数据通道</router-link> 
      </el-menu-item>
    </el-submenu> 
    <el-menu-item index="3"><a
        href="/useDoc"
      >使用文档</a></el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "Menu",
  props: {
    // msg: String,
    activeIndex: ''
  }
};
</script>
